import { formateDateToJalali, genderConverter } from "../../../utils/Functions";
import Table from "../../common/table";

const TempProfilesList = ({ data, profilesPage, setProfilesPage }: any) => {
  const pageSize = Math.round(data?.count / 10);

  const PaginationBtn = ({ number, isActive }: any) => {
    return (
      <button
        onClick={() => setProfilesPage(number)}
        className={`join-item btn btn-md shadow-none border-[1px] border-gray-100 hover:border-gray-100 hover:bg-gray-200 ${
          isActive ? "bg-gray-200" : "bg-white"
        }`}
      >
        {number}
      </button>
    );
  };

  const TdComponent = ({ children }: any) => {
    return <td className="whitespace-nowrap text-sm">{children}</td>;
  };

  return (
    <>
      <div className="overflow-x-auto mt-10 border rounded-xl">
        <Table
          header={[
            "",
            "نام و نام‌خانوادگی ",
            "تاریخ تولد ",
            "جنسیت",
            "تعداد آزمایش‌ها ",
          ]}
          body={data?.results?.map((user: any, idx: number) => (
            <tr key={idx}>
              <th>{idx + 1}</th>
              <TdComponent>
                {user.first_name} {user.last_name}
              </TdComponent>
              <TdComponent>{formateDateToJalali(user.birth_day)}</TdComponent>
              <TdComponent>{genderConverter(user.gender)}</TdComponent>
              <TdComponent>{user.test_count}</TdComponent>
            </tr>
          ))}
        />
      </div>
      {data?.count > 10 && (
        <div className="join flex justify-center mt-10">
          {Array.from({ length: pageSize }, (_, index) => (
            <PaginationBtn
              number={index + 1}
              isActive={profilesPage === index + 1}
              key={index}
            />
          ))}
        </div>
      )}
    </>
  );
};

export default TempProfilesList;
